export const environment = {
  production: true,
  context: '/mgtfe-ethique/',
  apiUrl: '/mgtfe-ethique/api/',
  casUrl: null
};

